const ACTIVITY_REPORTS_EXPORT_BY_EMPLOYEE = 'Activity Report Export By Employee';
const ACTIVITY_REPORTS_EXPORT_BY_PROJECT = 'Activity Report Export By Project';
const ACTIVITY_REPORTS_EXPORT_BY_COST_CODE = 'Activity Report Export By Cost Code';
const ACTIVITY_REPORTS_EXPORT_BY_EQUIPMENT = 'Activity Report Export By Equipment';
const ACTIVITY_REPORTS_EXPORT_BY_DAY = 'Activity Report Export By Day';
const ACTIVITY_REPORTS_EXPORT_BY_DATE_RANGE = 'Activity Report Export By Date Range';
const ACTIVITY_REPORTS_PRINT_BY_EMPLOYEE = 'Activity Report Print By Employee';
const ACTIVITY_REPORTS_PRINT_BY_PROJECT = 'Activity Report Print By Project';
const ACTIVITY_REPORTS_PRINT_BY_COST_CODE = 'Activity Report Print By Cost Code';
const ACTIVITY_REPORTS_PRINT_BY_EQUIPMENT = 'Activity Report Print By Equipment';
const ACTIVITY_REPORTS_PRINT_BY_DAY = 'Activity Report Print By Day';
const ACTIVITY_REPORTS_PRINT_BY_DATE_RANGE = 'Activity Report Print By Date Range';

const activityReportConstent = {
  ACTIVITY_REPORTS_EXPORT_BY_EMPLOYEE,
  ACTIVITY_REPORTS_EXPORT_BY_PROJECT,
  ACTIVITY_REPORTS_EXPORT_BY_COST_CODE,
  ACTIVITY_REPORTS_EXPORT_BY_EQUIPMENT,
  ACTIVITY_REPORTS_EXPORT_BY_DAY,
  ACTIVITY_REPORTS_EXPORT_BY_DATE_RANGE,
  ACTIVITY_REPORTS_PRINT_BY_EMPLOYEE,
  ACTIVITY_REPORTS_PRINT_BY_PROJECT,
  ACTIVITY_REPORTS_PRINT_BY_COST_CODE,
  ACTIVITY_REPORTS_PRINT_BY_EQUIPMENT,
  ACTIVITY_REPORTS_PRINT_BY_DAY,
  ACTIVITY_REPORTS_PRINT_BY_DATE_RANGE,
};
export default activityReportConstent;
